import axios from '@/axios';

const getSongUploadUrls = (payload: any) =>
  axios.post('/artist/get-song-upload-urls', payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

const songUpload = (payload: any) =>
  axios.post('/artist/song-upload', payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

const fetchSongs = (id: string) => axios.get(`/songs/${id}`);

export { getSongUploadUrls, songUpload, fetchSongs };
